import { useLocation, Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { jsonLdHtml } from "../lib/jsonld";

const LABELS = {
  occasions: "Occasions",
  diensten: "Diensten",
  "over-ons": "Over ons",
  reviews: "Reviews",
  contact: "Contact",
  afspraak: "Afspraak maken",
  inruil: "Inruilen",
  nieuws: "Tips",
  privacy: "Privacyverklaring",
  voorwaarden: "Algemene voorwaarden",
};

const SITE = "https://mpautobedrijf.com";

export default function Breadcrumbs() {
  const { pathname } = useLocation();
  if (pathname === "/" || pathname.startsWith("/admin")) return null;

  const parts = pathname.split("/").filter(Boolean);
  const crumbs = [{ label: "Home", to: "/" }];
  let acc = "";
  parts.forEach((p, i) => {
    acc += `/${p}`;
    const isId = i === parts.length - 1 && parts[0] === "occasions" && parts.length === 2;
    crumbs.push({ label: isId ? "Occasion" : (LABELS[p] || decodeURIComponent(p)), to: acc });
  });

  const jsonld = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.label,
      item: SITE + (c.to === "/" ? "" : c.to),
    })),
  };

  return (
    <nav aria-label="Breadcrumb" className="bg-zinc-950 border-b border-white/5" data-testid="breadcrumbs">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 py-3">
        <ol className="flex items-center flex-wrap gap-1.5 text-xs text-zinc-500">
          {crumbs.map((c, i) => (
            <li key={c.to} className="flex items-center gap-1.5">
              {i > 0 && <ChevronRight size={12} className="text-zinc-700" />}
              {i === crumbs.length - 1 ? (
                <span className="text-zinc-300">{c.label}</span>
              ) : (
                <Link to={c.to} className="hover:text-white transition-colors">{c.label}</Link>
              )}
            </li>
          ))}
        </ol>
      </div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLdHtml(jsonld) }} />
    </nav>
  );
}
